(() => {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer || drawer.dataset.smCartReady) return;
  drawer.dataset.smCartReady = 'true';
  drawer.addEventListener('click', event => {
    const opener = event.target.closest('[data-sm-vat-open]');
    if (!opener) return;
    const modal = document.getElementById('SmCartVat');
    modal?.show(opener);
    const link = modal?.querySelector('.sufio-vat-link');
    if (link) link.click();
  });
  const status = () => {
    const vatLink = drawer.querySelector('.sufio-vat-link');
    const label = drawer.querySelector('[data-sm-vat-label]');
    if (vatLink && label && /[A-Z]{2}[0-9]/.test(vatLink.textContent)) label.textContent = vatLink.textContent;
  };
  const observer = new MutationObserver(status);
  const vat = drawer.querySelector('#cart-page-vat-form');
  if (vat) observer.observe(vat, {childList: true, subtree: true, characterData: true});
  document.addEventListener('cart:updated', status);
})();
